// import { ApexOptions } from "apexcharts";

// // Base chart options shared across all bar charts
// const BASE_BAR_CHART_OPTIONS: ApexOptions = {
//   colors: ["#1976d2", "#388e3c"],
//   plotOptions: {
//     bar: {
//       horizontal: false,
//       columnWidth: "60%",
//       borderRadius: 4,
//     },
//   },
//   dataLabels: {
//     enabled: false,
//   },
//   legend: {
//     position: "top",
//     horizontalAlign: "center",
//   },
// };

// // Service categories bar graph chart options
// export const SERVICE_CATEGORIES_CHART_OPTIONS: ApexOptions = {
//   ...BASE_BAR_CHART_OPTIONS,
//   xaxis: {
//     categories: [],
//     labels: {
//       rotate: -45,
//       style: {
//         fontSize: "12px",
//       },
//     },
//   },
//   yaxis: [
//     {
//       title: {
//         text: "Number of Leads",
//       },
//     },
//   ],
//   tooltip: {
//     shared: true,
//     intersect: false,
//     y: [
//       {
//         formatter: (val: number) => `${val} leads`,
//       },
//       {
//         formatter: (val: number) => `${val}%`,
//       },
//     ],
//   },
//   grid: {
//     strokeDashArray: 4,
//   },
// };

// // Venue performance bar graph chart options
// export const VENUE_PERFORMANCE_CHART_OPTIONS: ApexOptions = {
//   ...BASE_BAR_CHART_OPTIONS,
//   xaxis: {
//     categories: [],
//     labels: {
//       rotate: -45,
//       style: {
//         fontSize: "12px",
//       },
//     },
//   },
//   yaxis: [
//     {
//       title: {
//         text: "Number of Leads",
//       },
//     },
//     {
//       opposite: true,
//       title: {
//         text: "Conversion Rate (%)",
//       },
//     },
//   ],
//   tooltip: {
//     shared: true,
//     intersect: false,
//     y: [
//       {
//         formatter: (val: number) => `${val} leads`,
//       },
//       {
//         formatter: (val: number) => `${val}%`,
//       },
//     ],
//   },
//   grid: {
//     borderColor: "#f1f1f1",
//     strokeDashArray: 5,
//   },
// };

// // Food performance bar graph chart options
// export const FOOD_PERFORMANCE_CHART_OPTIONS: ApexOptions = {
//   ...BASE_BAR_CHART_OPTIONS,
//   xaxis: {
//     categories: [],
//     labels: {
//       rotate: -45,
//       style: {
//         fontSize: "12px",
//       },
//     },
//   },
//   yaxis: [
//     {
//       title: {
//         text: "Number of Leads",
//       },
//     },
//     {
//       opposite: true,
//       title: {
//         text: "Conversion Rate (%)",
//       },
//     },
//   ],
//   tooltip: {
//     shared: true,
//     intersect: false,
//     y: [
//       {
//         formatter: (val: number) => `${val} leads`,
//       },
//       {
//         formatter: (val: number) => `${val}%`,
//       },
//     ],
//   },
//   grid: {
//     borderColor: "#f1f1f1",
//     strokeDashArray: 5,
//   },
// };

import { ApexOptions } from "apexcharts";

// Base chart options for donut graphs
const BASE_DONUT_CHART_OPTIONS: ApexOptions = {
  colors: ["#1976d2", "#388e3c", "#ff9800", "#f44336", "#9c27b0", "#00acc1"],
  plotOptions: {
    pie: {
      donut: {
        size: "65%",
        labels: {
          show: true,
          total: {
            show: true,
            label: "Total Leads",
            formatter: (w: any) => {
              const total = w.globals.seriesTotals.reduce(
                (a: number, b: number) => a + b,
                0,
              );
              return total.toString();
            },
          },
        },
      },
    },
  },
  dataLabels: {
    enabled: true,
    formatter: (val: number, opts: any) => {
      return `${val.toFixed(1)}%`;
    },
  },
  legend: {
    position: "bottom",
    horizontalAlign: "center",
    fontSize: "12px",
  },
  tooltip: {
    y: {
      formatter: (val: number, opts: any) => {
        return `${val} leads`;
      },
    },
  },
  labels: [],
};

// Service Categories Donut Chart Options
export const SERVICE_CATEGORIES_DONUT_OPTIONS: ApexOptions = {
  ...BASE_DONUT_CHART_OPTIONS,
  title: {
    text: "Leads by Service Category",
    align: "center",
    style: {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
};

// Venue Performance Donut Chart Options
export const VENUE_PERFORMANCE_DONUT_OPTIONS: ApexOptions = {
  ...BASE_DONUT_CHART_OPTIONS,
  title: {
    text: "Leads by Venue",
    align: "center",
    style: {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
};

// Food Performance Donut Chart Options
export const FOOD_PERFORMANCE_DONUT_OPTIONS: ApexOptions = {
  ...BASE_DONUT_CHART_OPTIONS,
  title: {
    text: "Leads by Food Menu",
    align: "center",
    style: {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
};

// Keep your existing bar chart options if still needed
export const BASE_BAR_CHART_OPTIONS: ApexOptions = {
  colors: ["#1976d2", "#388e3c"],
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "60%",
      borderRadius: 4,
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    position: "top",
    horizontalAlign: "center",
  },
};

export const SERVICE_CATEGORIES_CHART_OPTIONS: ApexOptions = {
  ...BASE_BAR_CHART_OPTIONS,
  xaxis: {
    categories: [],
    labels: {
      rotate: -45,
      style: {
        fontSize: "12px",
      },
    },
  },
  yaxis: [
    {
      title: {
        text: "Number of Leads",
      },
    },
  ],
  tooltip: {
    shared: true,
    intersect: false,
    y: [
      {
        formatter: (val: number) => `${val} leads`,
      },
      {
        formatter: (val: number) => `${val}%`,
      },
    ],
  },
  grid: {
    strokeDashArray: 4,
  },
};

export const VENUE_PERFORMANCE_CHART_OPTIONS: ApexOptions = {
  ...BASE_BAR_CHART_OPTIONS,
  xaxis: {
    categories: [],
    labels: {
      rotate: -45,
      style: {
        fontSize: "12px",
      },
    },
  },
  yaxis: [
    {
      title: {
        text: "Number of Leads",
      },
    },
    {
      opposite: true,
      title: {
        text: "Conversion Rate (%)",
      },
    },
  ],
  tooltip: {
    shared: true,
    intersect: false,
    y: [
      {
        formatter: (val: number) => `${val} leads`,
      },
      {
        formatter: (val: number) => `${val}%`,
      },
    ],
  },
  grid: {
    borderColor: "#f1f1f1",
    strokeDashArray: 5,
  },
};

export const FOOD_PERFORMANCE_CHART_OPTIONS: ApexOptions = {
  ...BASE_BAR_CHART_OPTIONS,
  xaxis: {
    categories: [],
    labels: {
      rotate: -45,
      style: {
        fontSize: "12px",
      },
    },
  },
  yaxis: [
    {
      title: {
        text: "Number of Leads",
      },
    },
    {
      opposite: true,
      title: {
        text: "Conversion Rate (%)",
      },
    },
  ],
  tooltip: {
    shared: true,
    intersect: false,
    y: [
      {
        formatter: (val: number) => `${val} leads`,
      },
      {
        formatter: (val: number) => `${val}%`,
      },
    ],
  },
  grid: {
    borderColor: "#f1f1f1",
    strokeDashArray: 5,
  },
};
